import { render, staticRenderFns } from "./DecretosView.vue?vue&type=template&id=a0e1c6c0"
import script from "./DecretosView.vue?vue&type=script&lang=ts"
export * from "./DecretosView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports